export namespace IEventsLog {
  export enum Action {
    MainEventsLog = 'MainEventsLog',
  }

  export enum Command {
    EventsLog = 'EventsLog',
  }

  export enum FilterItemType {
    Date = 'date',
    Input = 'input',
  }

  export interface FilterItems {
    type: FilterItemType;
    prop: string;
    placeholder?: string;
    defaultValue?: any;
    disabled?: boolean;
  }

  export interface EventProp {
    prop: string;
    label: string;
  }

  export interface PopupPayload {
    action: string;
    defaultEvents?: boolean;
    defaultFilters?: boolean;
    filters?: FilterItems[];
    eventProps?: EventProp[];
    requestParams?: IRequestParam[];
  }

  export interface IRequestParam {
    name: string;
    value: any;
  }

  export interface DefaultEventData {
    actionName: string;
    dateEvent: string;
    fieldsChanged: string;
    login: string;
    recordId: number;
  }
}
